import {Action, handleActions} from "redux-actions";
import {none, option} from "ts-option";
import {OrganizationState} from "./OrganizationState";
import {ORGANIZATION_FETCHED} from "../../action/organization/actionType";

/**
 * Initial state for organization data.
 */
const initState: OrganizationState = {
	organization: none,
};

const reducer = handleActions({
	[ORGANIZATION_FETCHED]: (state: OrganizationState, action: Action<ORGANIZATION_FETCHED>): OrganizationState => {
		return {...state, organization: option(action.payload.organization)}
	}
}, initState);

export default reducer;
